"use client";
import { useUpdateEffect } from "@ariakit/react-utils";
import { useStore, useStoreProps } from "@ariakit/react-store";
import * as Core from "@ariakit/components/collection/collection-store";
//#region src/collection/collection-store.ts
function useCollectionStoreProps(store, update, props) {
	useUpdateEffect(update, [props.store]);
	useStoreProps(store, props, "items", "setItems");
	return store;
}
function useCollectionStore(props = {}) {
	const [store, update] = useStore(Core.createCollectionStore, props);
	return useCollectionStoreProps(store, update, props);
}
//#endregion
export { useCollectionStore, useCollectionStoreProps };

//# sourceMappingURL=collection-store.js.map